__turbopack_context__.v({
  "aCount": "AccuracyStudiesSection-module__dpXWlq__aCount",
  "aOngoing": "AccuracyStudiesSection-module__dpXWlq__aOngoing",
  "aSoon": "AccuracyStudiesSection-module__dpXWlq__aSoon",
  "aTally": "AccuracyStudiesSection-module__dpXWlq__aTally",
  "aValidated": "AccuracyStudiesSection-module__dpXWlq__aValidated",
  "areaButton": "AccuracyStudiesSection-module__dpXWlq__areaButton",
  "areaColumnHead": "AccuracyStudiesSection-module__dpXWlq__areaColumnHead",
  "areaDot": "AccuracyStudiesSection-module__dpXWlq__areaDot",
  "areaName": "AccuracyStudiesSection-module__dpXWlq__areaName",
  "barTop": "AccuracyStudiesSection-module__dpXWlq__barTop",
  "cFig": "AccuracyStudiesSection-module__dpXWlq__cFig",
  "cGo": "AccuracyStudiesSection-module__dpXWlq__cGo",
  "cN": "AccuracyStudiesSection-module__dpXWlq__cN",
  "cRef": "AccuracyStudiesSection-module__dpXWlq__cRef",
  "cSen": "AccuracyStudiesSection-module__dpXWlq__cSen",
  "cStudy": "AccuracyStudiesSection-module__dpXWlq__cStudy",
  "chip": "AccuracyStudiesSection-module__dpXWlq__chip",
  "chips": "AccuracyStudiesSection-module__dpXWlq__chips",
  "closeBtn": "AccuracyStudiesSection-module__dpXWlq__closeBtn",
  "columnHead": "AccuracyStudiesSection-module__dpXWlq__columnHead",
  "context": "AccuracyStudiesSection-module__dpXWlq__context",
  "contextBar": "AccuracyStudiesSection-module__dpXWlq__contextBar",
  "contextDot": "AccuracyStudiesSection-module__dpXWlq__contextDot",
  "contextLabel": "AccuracyStudiesSection-module__dpXWlq__contextLabel",
  "figLabel": "AccuracyStudiesSection-module__dpXWlq__figLabel",
  "figNum": "AccuracyStudiesSection-module__dpXWlq__figNum",
  "flag": "AccuracyStudiesSection-module__dpXWlq__flag",
  "flagDot": "AccuracyStudiesSection-module__dpXWlq__flagDot",
  "frame": "AccuracyStudiesSection-module__dpXWlq__frame",
  "heading": "AccuracyStudiesSection-module__dpXWlq__heading",
  "inner": "AccuracyStudiesSection-module__dpXWlq__inner",
  "ledgerIndex": "AccuracyStudiesSection-module__dpXWlq__ledgerIndex",
  "list": "AccuracyStudiesSection-module__dpXWlq__list",
  "moreBtn": "AccuracyStudiesSection-module__dpXWlq__moreBtn",
  "moreRow": "AccuracyStudiesSection-module__dpXWlq__moreRow",
  "name": "AccuracyStudiesSection-module__dpXWlq__name",
  "panel": "AccuracyStudiesSection-module__dpXWlq__panel",
  "panelBody": "AccuracyStudiesSection-module__dpXWlq__panelBody",
  "panelCount": "AccuracyStudiesSection-module__dpXWlq__panelCount",
  "panelHead": "AccuracyStudiesSection-module__dpXWlq__panelHead",
  "panelTitle": "AccuracyStudiesSection-module__dpXWlq__panelTitle",
  "panelToggle": "AccuracyStudiesSection-module__dpXWlq__panelToggle",
  "pickerBox": "AccuracyStudiesSection-module__dpXWlq__pickerBox",
  "pickerChevron": "AccuracyStudiesSection-module__dpXWlq__pickerChevron",
  "pickerCount": "AccuracyStudiesSection-module__dpXWlq__pickerCount",
  "pickerDot": "AccuracyStudiesSection-module__dpXWlq__pickerDot",
  "pickerHead": "AccuracyStudiesSection-module__dpXWlq__pickerHead",
  "pickerLabel": "AccuracyStudiesSection-module__dpXWlq__pickerLabel",
  "pickerList": "AccuracyStudiesSection-module__dpXWlq__pickerList",
  "pickerRow": "AccuracyStudiesSection-module__dpXWlq__pickerRow",
  "pickerScrim": "AccuracyStudiesSection-module__dpXWlq__pickerScrim",
  "pickerTitle": "AccuracyStudiesSection-module__dpXWlq__pickerTitle",
  "progress": "AccuracyStudiesSection-module__dpXWlq__progress",
  "rowLink": "AccuracyStudiesSection-module__dpXWlq__rowLink",
  "rowStatic": "AccuracyStudiesSection-module__dpXWlq__rowStatic",
  "scrim": "AccuracyStudiesSection-module__dpXWlq__scrim",
  "section": "AccuracyStudiesSection-module__dpXWlq__section",
  "seg": "AccuracyStudiesSection-module__dpXWlq__seg",
  "sen": "AccuracyStudiesSection-module__dpXWlq__sen",
  "senDot": "AccuracyStudiesSection-module__dpXWlq__senDot",
  "sensors": "AccuracyStudiesSection-module__dpXWlq__sensors",
  "sub": "AccuracyStudiesSection-module__dpXWlq__sub",
  "toggle": "AccuracyStudiesSection-module__dpXWlq__toggle",
});
